module.exports = __webpack_public_path__ + "mo/img/designer.6d6b15d0.webp";